import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    id: {type: Number, default: undefined},
    moduleId: Number,
    paragraphExtensionFormUrl: String,
    paragraphExtensionUsed: {type: Number, default: undefined},
    type: String,
    order: Number,
    isLast: Boolean,
  }

  static outlets = ['lesson'];
  static targets = ['lessonText', 'code'];

  lessonTextTargetConnected(element) {
    [
      ...element.querySelectorAll(':scope > p, :scope > ul > li, :scope > ol > li')
    ].map( (el) => {
      el.addEventListener('click', () => {
        if (!el.turbo_frame) {
          const turboFrameTemplate = document.querySelector('#paragraph-extend-form[template]');
          const turbo_frame = turboFrameTemplate.cloneNode(true);
          turbo_frame.removeAttribute('template');
          turbo_frame.setAttribute('data-paragraph-extension-form-url-value', this.paragraphExtensionFormUrlValue);

          // We have to set highlight before we insert turbo_frame into the element
          turbo_frame.querySelectorAll('#id_highlight').forEach((highlight) => highlight.value = el.innerHTML)
          if (this.idValue !== undefined) {
            turbo_frame.querySelectorAll('#id_chunk').forEach((chunk) => chunk.value = this.idValue)
          }
          // Insert turbo-frame right after the element
          el.insertAdjacentElement('afterend', turbo_frame);
          // // Insert into the element
          // el.appendChild(turbo_frame);
          // // el.parentNode.insertBefore(turbo_frame, el.nextSibling);
          el.turbo_frame = turbo_frame;
        }
      });
    });

    if (this.paragraphExtensionUsedValue < 1 && this.typeValue === 'lesson' && this.orderValue == 1) {
      const p = element.querySelector(':scope > p');

      if (p){
        const alert = document.createElement('div');
        alert.innerHTML = '<div><svg class="bi" width="20" height="20" fill="currentColor"><use xlink:href="#magic-wand"></use></svg></div><span><strong>Tip:</strong> Click on any paragraph in the text to find out how to apply this to your goal!</span><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'
        alert.setAttribute('class', 'alert alert-info alert-dismissible fade show');
        p.insertAdjacentElement('afterend', alert);
      }
    }

    import('fslightbox').then(({ default: FsLightbox }) => {
      refreshFsLightbox()
    });
  }

  codeTargetConnected(element) {
    import('mermaid').then(({default: mermaid}) => {
      mermaid.initialize({
        startOnLoad: false,
        securityLevel: 'loose',
      });
      mermaid.run({
        nodes: [element],
      }).then(() => {
        import('svg-pan-zoom').then(({default: svgPanZoom}) => {
          svgPanZoom(
            element.querySelector('svg'),
            {
              zoomEnabled: true,
              controlIconsEnabled: true,
              fit: true,
              center: true
            }
          );
        })
      }, (err) => {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        element.classList.add('d-none');

        fetch(`/courses/fix-diagram-error/${element.getAttribute('data-diagram-id')}/`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': csrfToken,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: `error=${err.message}`
        });

      });

    });
  }

}
